/**
 * Defines the layout strategy for PLP filters.
 */
export enum FilterLayout {
  TopBar = 'topBar',
  Sidebar = 'sidebar'
}
